export const sortFields = {
  CREATE_DATE: "create_date",
  ACTION_AND_REWARD: "action_and_reward",
};

export const sortDirection = {
  ASC: "",
  DESC: "-"
};

export const sortUseList = [
  {
    label: "sortByDate",
    key: sortFields.CREATE_DATE,
  }
  // {
  //     label: "sortByAlphabet",
  //     key: sortFields.REWARD_SUMMARY
  // }
];

export const MAX_PER_PAGE = 10;

export const TABS = {
  EARN: 0,
  USE: 1
};
